module.exports = __webpack_public_path__ + "static/media/pin.fd74782a.svg";